module.exports = __webpack_public_path__ + "img/geotec-logo.c66ad372.png";